/* import __COLOCATED_TEMPLATE__ from './reporting-content-tab.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();